import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { userListLoad } from "store/models/user";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const UserSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={userListLoad}
      filter={{ simple: true }}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, activeFilter, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: 200 }}
              onChange={onChange}
              showSearch={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option.props.children;
                return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              disabled={disabled}
            >
              {!props.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`user${item.id}`} value={item.id}>
                  {item.email}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.user,
});

export default connect(mapState)(UserSelect);
